import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { RupeePipe } from '@app/shared/pipes/rupee.pipe';
import { NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'app-floating-view',
    templateUrl: './floating-view.component.html',
    styleUrls: ['./floating-view.component.scss'],
    standalone: true,
    imports: [MatDialogModule, NgTemplateOutlet, RupeePipe]
})
export class FloatingViewComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FloatingViewComponent>,
  ) {
    if (!this.data.isCreditsUsed) {
      this.data.info = this.data.info.filter(item => item.type !== 'Credit');
    }
  }

  close() {
    this.dialogRef.close();
  }

}
